import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import birthdayService from "../../services/data/birthday.service"
import BirthdayMural from "./BirthdayMural"

export default function BirthdaySearch() {
    const companyId = localStorage.getItem("companyId")
    const [query, setQuery] = useState("")
    const [results, setResults] = useState([])
    const [loading, setLoading] = useState(false)
    const [selectedEmployee, setSelectedEmployee] = useState(null)
    const [giftMsg] = useState("")
    const [sending, setSending] = useState(false)
    const [sent, setSent] = useState(false)

    function handleSearch(e) {
        e.preventDefault()
        if (!query.trim()) return
        setLoading(true)
        birthdayService.search({ company_id: companyId, q: query })
            .then(setResults)
            .catch(console.error)
            .finally(() => setLoading(false))
    }

    function sendGift(emp) {
        setSending(true)
        birthdayService.sendGift({
            company_id: companyId,
            employee_id: emp.id,
            gift_type: "email",
            message: giftMsg || `Parabéns pelo seu aniversário, ${emp.name}! 🎉`,
        }).then(() => setSent(true))
          .catch(console.error)
          .finally(() => setSending(false))
    }

    return (
        <div>
            <form onSubmit={handleSearch} className="d-flex gap-2 mb-4">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar colaborador pelo nome..."
                    value={query}
                    onChange={e => setQuery(e.target.value)}
                />
                <button type="submit" className="btn btn-success px-4">
                    <FontAwesomeIcon icon={solid("magnifying-glass")} />
                </button>
            </form>

            {loading && <div className="text-muted small">Buscando...</div>}

            {results.map((emp) => (
                <div key={emp.id} className="d-flex align-items-center py-3 border-bottom">
                    {emp.photo
                        ? <img src={emp.photo} alt={emp.name} width="44" height="44" className="rounded-circle me-3 object-fit-cover" />
                        : <div className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center me-3" style={{ width: 44, height: 44 }}>
                            {emp.name[0]}
                        </div>
                    }
                    <div className="flex-grow-1">
                        <div className="fw-bold text-default">
                            {emp.name}
                            {emp.is_today && <span className="ms-2 badge bg-warning text-dark">🎂 Hoje!</span>}
                        </div>
                        <div className="text-muted small">{emp.position}</div>
                        <div className="text-green small">
                            {emp.birthday_day}/{emp.birthday_month}
                        </div>
                    </div>
                    <div className="d-flex gap-2">
                        <button
                            className="btn btn-sm btn-outline-success"
                            onClick={() => setSelectedEmployee(emp)}
                            title="Ver mural de parabéns"
                        >
                            <FontAwesomeIcon icon={solid("comments")} />
                        </button>
                        <button
                            className="btn btn-sm btn-success"
                            onClick={() => sendGift(emp)}
                            disabled={sending}
                            title="Enviar parabéns por email"
                        >
                            <FontAwesomeIcon icon={solid("envelope-circle-check")} />
                        </button>
                    </div>
                </div>
            ))}

            {sent && (
                <div className="alert alert-success mt-3">
                    Mensagem enviada com sucesso! 🎉
                </div>
            )}

            {selectedEmployee && (
                <div className="mt-4">
                    <div className="d-flex align-items-center gap-2 mb-2">
                        <button className="btn btn-sm btn-link p-0" onClick={() => setSelectedEmployee(null)}>
                            ← Voltar
                        </button>
                        <span className="fw-bold text-default">Mural de Parabéns — {selectedEmployee.name}</span>
                    </div>
                    <BirthdayMural employeeId={selectedEmployee.id} employeeName={selectedEmployee.name} />
                </div>
            )}
        </div>
    )
}
